import { Drawer } from 'antd';
import React, { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { setCookies } from 'src/store/app/actions';
import { RootState } from 'src/types/store-types';
import './styles.scss';

const CookiesAcceptor: FC = () => {
  const { t } = useTranslation();
  const { cookiesAccepted } = useSelector((state: RootState) => state.app);
  const _setCookies = useConnectedAction(setCookies);

  const handleCookiesAccept = (): void => {
    _setCookies();
  };

  return (
    <Drawer
      style={{
        position: isMobile ? 'fixed' : 'initial',
        bottom: 0,
        height: isMobile ? '90px' : '100%',
        backgroundColor: 'var(--navigation-background)',
        color: 'var(--text-primary)',
      }}
      placement="bottom"
      closable={false}
      open={!cookiesAccepted}
      zIndex={99}
      autoFocus={false}
      key="bottom"
      height="unset"
      mask={false}
      rootStyle={isMobile ? {} : { width: '50%', maxWidth: 470, margin: '0 auto' }}
    >
      <div className="acceptCookies_container">
        <p>{t('acceptCookies')}</p>
        <div className="acceptCookies_container_btn">
          <Button className="primary-filled-btn" size="md" onClick={handleCookiesAccept}>
            {t('accept')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
export default CookiesAcceptor;
